import KinshipLogo from './kinship-logo-new.png';
import BgImage from './bg-image.png';
import LoginImage from './login-image.png';
import ProfileHeader from './profile-header.png';
import Loader from './Loader-myk.gif';

export const Images = {
  KinshipLogo,
  BgImage,
  LoginImage,
  ProfileHeader,
  Loader
};
